
import { http } from "@/helpers/http";
import Vue from 'vue'

// const baseURL = 'https://hkfgeidtia.execute-api.us-east-1.amazonaws.com/dev/v1';
// const baseURL = "https://f0pm5tx8l1.execute-api.ap-southeast-1.amazonaws.com/dev/v1"; //sg
// const baseURL = 'http://localhost:3000/dev/v1';

const baseURL = "/dashboard/v1";

export default {
    namespaced: true,
    state: {
        dashboardData: null,
        sideNav: true,
        cancelTokenSource: null,
    },

    mutations: {
        setCancelTokenSource(state, cancelTokenSource) {
            state.cancelTokenSource = cancelTokenSource;
        },

        setDashboardData(state, dashboardData) {
            Vue.set(state, 'dashboardData', dashboardData);
        },

        setSideNav(state, sideNav) {
            Vue.set(state, 'sideNav', sideNav);
        },
    },
    actions: {
        showSideNav({ state, commit, rootState }, payload) {
            commit("setSideNav", true);
        },

        hideSideNav({ state, commit, rootState }, payload) {
            commit("setSideNav", false);
        },

        getDashboardData({ state, commit, rootState }, payload) {
            http.get(baseURL + "/dashboard").then(response => {
                if (payload.callback) payload.callback(true, response.data);
            }).catch(error => {
                if (payload.callback) payload.callback(false);
            })
        }

    }
}